const FormSection = ({ title, children, primaryColor, secondaryColor }) => (
    <div
      style={{
        padding: "16px",
        background: "white",
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: primaryColor,
          fontSize: "32px",
          fontFamily: "Mauren, sans-serif",
          fontWeight: "100",
          margin: 0,
        }}
      >
        {title}
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        {children}
      </div>
    </div>
  );

  export default FormSection;